<template>
  <div class="numeric-input">
    <input v-if="!readOnly" v-model="internalValue"/>
    <span v-else class="value">{{value}}</span>
  </div>
</template>

<script>
import inputMixin from '@/mixins/inputMixin'

export default {
  name: 'NumericInput',
  mixins: [inputMixin]
}
</script>

<style lang="stylus" scoped>
.input-field
  input
    m-font-size(14,15)
    border none
    height 36px
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 4px;
    min-width 20px
</style>